import React from 'react'

import { InsertionFlowScreensProps } from '../../../../../@types/props-types'
import { SCREEN_COSTS, SCREENS } from '../../../../../services/domain/wizardScreens'
import { CostsScreenValidationResult } from '../../../../../@types/validation-types'
import { FieldProps, TooltipTypes } from '../../../../../@types/types'
import ScreenContainer from '../../../../common/containers/screenContainer/ScreenContainer'
import { ScreenLayout } from '../../../../common/containers/screenLayout/ScreenLayout'
import { ScreenTooltip } from '../../../../common/display/screenTooltip/ScreenTooltip'
import { IconS24BuildingEuro24 } from '@is24/cosma-ui-icons'
import { isWebView } from '../../../../../utils/navigation'
import styles from '../../../../common/containers/screenLayout/ScreenLayout.module.css'

const screen = SCREENS[SCREEN_COSTS]
type AdditionalCostsProps = {
  headerKey?: string
  screenTooltipKey?: string
  headerIcon?: React.ReactElement
  children: (costsWrapperProps: FieldProps<CostsScreenValidationResult>) => React.ReactElement
}
const Costs: React.FC<InsertionFlowScreensProps<CostsScreenValidationResult> & AdditionalCostsProps> = ({
  insertionData,
  validationMessages,
  onChange,
  onNavigate,
  doReset,
  headerKey = 'wizard.screen.costs.header',
  screenTooltipKey,
  headerIcon = <IconS24BuildingEuro24 />,
  children,
}) => {
  const isMobile = isWebView()

  const displayAppropriateTooltip = (tooltipType: TooltipTypes) => {
    return screenTooltipKey ? <ScreenTooltip tooltipType={tooltipType} tooltipKey={screenTooltipKey} /> : <></>
  }

  const wrapperProps: FieldProps<CostsScreenValidationResult> = {
    validationMessages: validationMessages,
    insertionData: insertionData,
    screenName: screen.name,
    screenId: screen.id,
    doReset: doReset,
    onChange: onChange,
  }

  return (
    <ScreenContainer
      className={isMobile ? 'margin-bottom-xxl' : ''}
      disableMarginBottom={isMobile}
      containerId={screen.id}
      onNavigate={onNavigate}
      screen={screen}
    >
      <ScreenLayout
        id={`${screen.id}-desk-tooltip`}
        headline={headerKey}
        screenName={screen.name}
        deskTooltip={displayAppropriateTooltip(TooltipTypes.DESKTOP)}
        headerIcon={headerIcon}
        mobileTooltip={displayAppropriateTooltip(TooltipTypes.MOBILE)}
        sectionClassName={styles.allowOverflow}
      >
        {children(wrapperProps)}
      </ScreenLayout>
    </ScreenContainer>
  )
}

export default Costs
